var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalconyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14H14.3333V11H14.5C14.776 11 15 10.776 15 10.5C15 10.224 14.776 10 14.5 10H13V3.83333C13 2.822 12.178 2 11.1667 2H5.83333C4.822 2 4 2.822 4 3.83333V10H2.5C2.224 10 2 10.224 2 10.5C2 10.776 2.224 11 2.5 11H2.66667V14H2.5C2.224 14 2 14.224 2 14.5C2 14.776 2.224 15 2.5 15H14.5C14.776 15 15 14.776 15 14.5C15 14.224 14.776 14 14.5 14ZM5 3.83333C5 3.374 5.374 3 5.83333 3H11.1667C11.626 3 12 3.374 12 3.83333V10H5V3.83333ZM5.33333 14H3.66667V11H5.33333V14ZM8 14H6.33333V11H8V14ZM10.6667 14H9V11H10.6667V14ZM13.3333 14H11.6667V11H13.3333V14Z",
    fill: "#FFA425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalconyIcon);
export default __webpack_public_path__ + "static/media/balcony-icon.add830dd71a8ef98797abab3cdb13c48.svg";
export { ForwardRef as ReactComponent };